export enum ROUTES {
  Home = "/",
  Epic = "/epic",
  Galaxy = "/galaxy",
  Form = "/form"
} 